import React from "react";






function Auth() {
	return (
		<div className="information">
			<form action="index.php" method="POST" enctype="multipart/form-data">
				<div className="form-group">
					<label htmlFor="exampleInputPassword1">Логин</label>
					<input type="text" className="form-control" id="exampleInputPassword1" placeholder="Введите идентификатор" />
					
				</div>

				<div className="butn-holder">
				<button type='submit' className="butn butn-5 hover-border-11">
					<span>Войти</span>
				</button>
				<input type="hidden" name="id" value="Authorisation/Login"></input>
			</div>
			</form>
			
		</div>








	)
}


export default Auth